import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useCurrentUser } from './useCurrentUser.tsx';

export function FinanceRoute() {
  const { user, role } = useCurrentUser();

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }

  if (role !== 'admin' && role !== 'finanza') {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
